// Same labels as the vammo default today. Kept explicit so Batfin stays on battery
// labels if the default for unlisted orgs ever changes; do not delete as a duplicate.
export const batfinLangSettings = {
  digitalTwinSingleLabel: "inventory:tabs.battery.single_label",
  digitalTwinLabel: "inventory:tabs.battery.label",
  digitalTwinAddResource: "inventory:tabs.battery.add_resource",
};
